<ng-container [formGroup]="scopeForm">
  <ng-container formArrayName="validScopes">
    <div class="row d-flex">
      <ng-container *ngFor="let scope of validScopesArray?.controls; let i = index" [formGroupName]="i">
        <div class="col">

          <mat-form-field appearance="outline" class="w-50 mt-2">
            <mat-label>Scope Type </mat-label>
            <mat-select formControlName="scopeType" name="scopeType" id="scopeType">
              <mat-option *ngFor="let type of scopeTypes" [value]="type">
                {{ type }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col">
          <div class="user-info-item border-0 w-100">
              <!-- Multi select -->
              <mat-form-field appearance="outline" class="w-50 mt-2">
                <mat-label>Select Scope</mat-label>
                <mat-select formControlName="scopeName"
                            [multiple]="true"
                            [disableOptionCentering]="true"
                            placeholder="Select Scope">
                            <ng-container *ngIf="getScopeNamesForType(i).length > 0; else noData">
                              <mat-option *ngFor="let item of getScopeNamesForType(i)" [value]="item">
                                {{ item | titlecase }}
                              </mat-option>
                            </ng-container>
                            <ng-template #noData>
                              <mat-option disabled>No data to display</mat-option>
                            </ng-template>
                </mat-select>
              </mat-form-field>
              <button mat-icon-button [disabled]="disabled" color="warn" (click)="removeScope(i)">
              <mat-icon>delete</mat-icon>
              </button>
              </div> 
        </div> 
      </ng-container>
      <div class="d-flex mt-1" *ngIf="validScopesArray?.controls.length < 1">
        <p class="label d-block">&nbsp;&nbsp;&nbsp;&nbsp;</p>
        <button [disabled]="validScopesArray?.length >= max || disabled" class="btn btn-primary" (click)="addNewScope()"><i class="bi bi-plus"></i>Add Scope</button>
      </div>
    </div>
  </ng-container>
</ng-container>
